import { StarIcon } from "@heroicons/react/20/solid";
import React from "react";

interface RatingProps {
    rating: number;
    onChange: (rating: number) => void;
}

export const Rating: React.FC<RatingProps> = props => {
    const [hoveredIndex, setHoveredIndex] = React.useState<number | null>(null);
    return (
        <div className="flex flex-row items-center flex-nowrap">
            {[1, 2, 3, 4, 5].map((_, index) => {
                return (
                    <StarIcon
                        key={index}
                        className={`h-5 w-5  cursor-pointer ${
                            hoveredIndex === index
                                ? "text-yellow-500"
                                : index < (hoveredIndex ?? props.rating)
                                ? "text-yellow-400"
                                : "text-gray-300"
                        }`}
                        onClick={() => props.onChange(index + 1)}
                        onMouseEnter={() => setHoveredIndex(index)}
                        onMouseLeave={() => setHoveredIndex(null)}
                    />
                );
            })}
        </div>
    );
};

interface RatingDisplayProps {
    rating: number;
}

interface PartialStarProps {
    percentage: number; // 0 to 100
    size?: number; // optional icon size in pixels
    filledColor?: string;
    emptyColor?: string;
}

export const PartialStar: React.FC<PartialStarProps> = ({
    percentage,
    size = 20,
    filledColor = "#facc15", // tailwind yellow-400
    emptyColor = "#e5e7eb", // tailwind gray-200
}) => {
    const fillWidth = `${percentage}%`;

    return (
        <div style={{ position: "relative", width: size, height: size }}>
            {/* Base empty star */}
            <StarIcon style={{ color: emptyColor, width: size, height: size }} />

            {/* Overlay filled star with clipping */}
            <div
                style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: fillWidth,
                    height: size,
                    overflow: "hidden",
                }}>
                <StarIcon style={{ color: filledColor, width: size, height: size }} />
            </div>
        </div>
    );
};

export const RatingDisplay: React.FC<RatingDisplayProps> = props => {
    const maxRating = 5;
    return (
        <div className="flex items-center flex-nowrap">
            <div className="flex items-center">
                {Array.from({ length: Math.floor(props.rating) }, (_, index) => (
                    <PartialStar key={index} percentage={100} />
                ))}
                {props.rating % 1 !== 0 ? (
                    <PartialStar percentage={(props.rating % 1) * 100} />
                ) : null}
                {Array.from(
                    { length: maxRating - Math.ceil(props.rating) },
                    (_, index) => (
                        <PartialStar key={index} percentage={0} />
                    ),
                )}
            </div>
        </div>
    );
};
